import { iaRa } from 'lib/helpers/utility';

import { availableTimes as defaultAvailableTimes } from 'components/practice/Settings/components/Calendar/components/AvailableTime/lib';

const formInitialValues = (practice, locations = []) => {
  return {
    ...practice,
    headerPhoto: practice?.header_photo || null,
    dbaName: practice?.dba_name || '',
    keepDbaNameAsTyped: false,
    addressLabel: practice?.address_label || '',
    address: {
      id: practice?.practiceAddress?.id || null,
      address_ln_1: practice?.practiceAddress?.address_ln_1 || '',
      address_ln_2: practice?.practiceAddress?.address_ln_2 || '',
      city: practice?.practiceAddress?.city || '',
      state: practice?.practiceAddress?.state || '',
      zip: practice?.practiceAddress?.zip || ''
    },
    locations: iaRa(locations).map((location) => ({
      id: location?.id,
      label: location?.label || '',
      address: {
        id: location?.address?.id || null,
        address_ln_1: location?.address?.address_ln_1 || '',
        address_ln_2: location?.address?.address_ln_2 || '',
        city: location?.address?.city || '',
        state: location?.address?.state || '',
        zip: location?.address?.zip || ''
      }
    })),
    displaySettings: {
      ...(practice?.display_settings || {})
    },
    stickyNotesAlert: practice?.display_settings?.sticky_notes?.alert || false,
    requireInvoiceReview: practice?.display_settings?.require_invoice_review || false,
    allowTips: practice?.display_settings?.allow_tips || false,
    surchargeEnabled: practice?.surcharge_enabled || false,
    surchargeAmount: (practice?.surcharge_percentage ?? 0) * 100,
    batchTime: practice?.display_settings?.billing?.payment?.batch_time || '09:00',
    availableTimes: practice?.available_times || defaultAvailableTimes,
    timezone: practice?.timezone || null
  };
};

export default formInitialValues;
